import { defineComponent as _defineComponent } from 'vue'
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'LearningProgressPolicyModal',
  props: {
    policyUrl: {
      type: String,
      required: true,
    },
  },
  setup(__props) {

  

return { __sfc: true,VuePdfEmbed }
}

})